import { AccountModel, AccountTokenModel } from '../account';
import { baseClient } from '../common';
import { ChangePasswordModel } from './change-password.model';
import { UpdateUserModel } from './update-user.model';
import { UserModel } from './user.model';

const apiUrl = `/api/users`;

export const userClient = {
  getActive: (): Promise<UserModel> => {
    return baseClient.get<UserModel>(`${apiUrl}/active`);
  },

  updateActive(model: UpdateUserModel): Promise<UserModel> {
    return baseClient.body<UpdateUserModel, UserModel>({
      url: `${apiUrl}/active`,
      method: 'POST',
      body: model,
    });
  },

  changePassword(model: ChangePasswordModel): Promise<void> {
    return baseClient.body<ChangePasswordModel, void>({
      url: `${apiUrl}/change-password`,
      method: 'POST',
      body: model,
    });
  },

  getToken(accountId: string, init?: RequestInit): Promise<AccountTokenModel> {
    return baseClient.get<AccountTokenModel>(
      `${apiUrl}/token/${accountId}`,
      init,
    );
  },

  getAccounts(): Promise<AccountModel[]> {
    return baseClient.get<AccountModel[]>(`${apiUrl}/accounts`);
  },

  delete(): Promise<void> {
    return baseClient.delete(`${apiUrl}`);
  },
};
